import type { OperationsNode } from '../types/operations.types'
import { isTeamNode } from './nodeTypes'

/**
 * Divisions anywhere beneath a node, not counting the node itself — the
 * Divisions figure for a panel whose own children are conferences, so its
 * child count alone would hide how many divisions sit under them.
 */
export const divisionCountForNode = (node: OperationsNode): number =>
  isTeamNode(node)
    ? 0
    : node.children.reduce(
        (total, child) =>
          total +
          (!isTeamNode(child) && child.type === 'division' ? 1 : 0) +
          divisionCountForNode(child),
        0
      )
